import { addEventListener, instrumentMethod, Observable, shallowClone } from '@datadog/browser-core';
export function createLocationChangeObservable(configuration) {
  var currentLocation = shallowClone(location);
  return new Observable(function (observable) {
    var _trackHistory = trackHistory(configuration, onLocationChange),
      stopHistoryTracking = _trackHistory.stop;
    var _trackHash = trackHash(configuration, onLocationChange),
      stopHashTracking = _trackHash.stop;
    function onLocationChange() {
      if (currentLocation.href === location.href) {
        return;
      }
      var newLocation = shallowClone(location);
      observable.notify({
        newLocation: newLocation,
        oldLocation: currentLocation
      });
      currentLocation = newLocation;
    }
    return function () {
      stopHistoryTracking();
      stopHashTracking();
    };
  });
}
function trackHistory(configuration, onHistoryChange) {
  var _instrumentMethod = instrumentMethod(getHistoryInstrumentationTarget('pushState'), 'pushState', function (_ref) {
      var onPostCall = _ref.onPostCall;
      onPostCall(onHistoryChange);
    }),
    stopInstrumentingPushState = _instrumentMethod.stop;
  var _instrumentMethod2 = instrumentMethod(getHistoryInstrumentationTarget('replaceState'), 'replaceState', function (_ref2) {
      var onPostCall = _ref2.onPostCall;
      onPostCall(onHistoryChange);
    }),
    stopInstrumentingReplaceState = _instrumentMethod2.stop;
  var _addEventListener = addEventListener(configuration, window, "popstate" /* DOM_EVENT.POP_STATE */, onHistoryChange),
    removeListener = _addEventListener.stop;
  return {
    stop: function stop() {
      stopInstrumentingPushState();
      stopInstrumentingReplaceState();
      removeListener();
    }
  };
}
function trackHash(configuration, onHashChange) {
  return addEventListener(configuration, window, "hashchange" /* DOM_EVENT.HASH_CHANGE */, onHashChange);
}
function getHistoryInstrumentationTarget(methodName) {
  // Ideally we should always instument the method on the prototype, however some frameworks (e.g [Next.js](https://github.com/vercel/next.js/blob/d3f5532065f3e3bb84fb54bd2dfd1a16d0f03a21/packages/next/src/client/components/app-router.tsx#L429))
  // are wrapping the instance method. In that case we should also wrap the instance method.
  return Object.prototype.hasOwnProperty.call(history, methodName) ? history : History.prototype;
}